<template>
  <div>
    <tabs pills
          type="secondary"
          tab-nav-classes="justify-content-end"
          tab-content-classes="tab-space">
      <tab-pane v-for="stat in stats"
                :key="stat.name"
                :before-change="() => getData(stat.name)"
                :title="$t(`generic.filters.${stat.name}`)"
                :id="stat.name">
        <div class="row d-flex justify-content-between">
          <stats-card :title="model.views"
                      :loading="statsLoading"
                      class="dashboard-stats"
                      :small-title="$t('dashboard.stats.jobViews')"
                      type="info"
                      icon="nc-icon nc-chart-pie-36">
          </stats-card>
          <stats-card :title="model.applicants"
                      :loading="statsLoading"
                      class="dashboard-stats"
                      :small-title="$t('dashboard.stats.applicants')"
                      type="danger"
                      icon="nc-icon nc-paper">
          </stats-card>
          <stats-card :title="model.jobs"
                      :loading="statsLoading"
                      class="dashboard-stats clickable"
                      @click.native="goToJobs"
                      :small-title="$t('dashboard.stats.jobPosts')"
                      type="danger"
                      icon="nc-icon nc-briefcase-24">
          </stats-card>
        </div>
        <div class="row d-flex justify-content-between">
          <stats-card :title="model.apply_start"
                      :loading="statsLoading"
                      class="dashboard-stats"
                      :small-title="$t('dashboard.stats.sales')"
                      type="success"
                      icon="nc-icon nc-money-coins">
          </stats-card>
          <stats-card :title="model.clients"
                      :loading="statsLoading"
                      class="dashboard-stats clickable"
                      @click.native="goToClients"
                      :small-title="$t('dashboard.stats.clients')"
                      type="info"
                      icon="nc-icon nc-bank">
          </stats-card>
          <stats-card :title="model.credits"
                      :loading="statsLoading"
                      class="dashboard-stats clickable"
                      @click.native="goToCredits"
                      :small-title="$t('dashboard.stats.credits')"
                      type="info"
                      icon="nc-icon nc-key-25">
          </stats-card>
        </div>
      </tab-pane>
    </tabs>
    <div class="row">
      <div class="col-12">
        <dashboard-orders></dashboard-orders>
      </div>
      <div class="col-12">
        <dashboard-clients></dashboard-clients>
      </div>
    </div>
  </div>
</template>
<script>
  import DashboardService from 'src/services/DashboardService'
  import { Tabs, TabPane, StatsCard } from 'src/components'

  import DashboardClients from './DashboardClientList'
  import DashboardOrders from './DashboardOrderList'
  import entities from 'src/config/entities'
  import { getRouteName, routeTypes } from 'src/config/routeTypes'

  export default {
    name: 'dashboard',
    components: {
      Tabs,
      TabPane,
      StatsCard,
      DashboardClients,
      DashboardOrders
    },
    data () {
      return {
        activeStat: 'today',
        statsLoading: false,
        model: {
          views: 0,
          click_out: 0,
          apply_start: 0,
          applicants: 0,
          orders: 0,
          jobs: 0,
          clients: 0,
          credits: 0
        },
        stats: [
          {
            name: 'today'
          },
          {
            name: 'week'
          },
          {
            name: 'month'
          },
          {
            name: 'year'
          },
          {
            name: 'total'
          }
        ]
      }
    },
    computed: {},
    methods: {
      async getData (id) {
        if (id !== this.activeStat) {
          this.statsLoading = true
          this.activeStat = id
          try {
            let {data} = await DashboardService.getDashboard(this.activeStat)
            this.model = data
          } finally {
            this.statsLoading = false
          }
        }
      },
      goToJobs () {
        this.$router.push({name: getRouteName(routeTypes.LIST, entities.JOB)})
      },
      goToClients () {
        this.$router.push({name: getRouteName(routeTypes.LIST, entities.CLIENT)})
      },
      goToCredits () {
        this.$router.push({name: getRouteName(routeTypes.LIST, entities.CREDIT), hash: '#logs'})
      }
    },
    async beforeRouteEnter (to, from, next) {
      try {
        let res = await DashboardService.getDashboard()
        let data = res.data
        if (data) {
          next(vm => {
            vm.model = data
          })
        } else {
          next(vm => vm.error = 'No data')
        }

      } catch (e) {
        next(vm => vm.error = e)
      }
    }

  }
</script>
<style lang="scss" scoped>
  .dashboard-stats {
    min-width: 270px;
    flex: 1;
    margin: 10px 20px;
    &.clickable {
      cursor: pointer;
    }
  }
</style>
